import { useTranslation } from 'next-i18next/pages';
import { P } from '../Text';
import Link from 'next/link';

// A notice shown in the yellow bar above the home page navigation. `title`
// and `message` are translation keys; add them to public/locales/en and hu.
// `href` makes the bar a link: a page path, or `#newsletter` to jump to and
// focus the newsletter field in the footer. Without it the bar is plain text.
export interface IInfoNotice {
  title?: string;
  message?: string;
  href?: string;
}

interface IConditionalInfoHeaderProps {
  newsLetterRef: any;
  notice?: IInfoNotice | null;
}

const ConditionalInfoHeader: React.FC<IConditionalInfoHeaderProps> = ({
  newsLetterRef,
  notice,
}) => {
  const { t } = useTranslation();

  // No notice, no bar: an empty yellow strip would push the page down.
  if (!notice?.title && !notice?.message) return null;

  const handleClick = () => {
    // The newsletter anchor also focuses its input, so the visitor can type.
    if (notice.href === '#newsletter' && newsLetterRef.current) {
      newsLetterRef.current.focus();
    }
  };

  const text = (
    <P centered>
      {notice.title && <b>{t(notice.title)}</b>}
      {notice.title && notice.message && ' - '}
      {notice.message && t(notice.message)}
    </P>
  );

  return (
    <div
      id="conditionalHeader"
      className={`bg-tt-conditional-header p-0 py-4 text-sm h-14`}
    >
      <div className="text-center h-6 flex items-center justify-center">
        {notice.href ? (
          <Link
            href={notice.href}
            onClick={handleClick}
            className="flex items-center min-h-[1.5rem]"
          >
            {text}
          </Link>
        ) : (
          text
        )}
      </div>
    </div>
  );
};

export default ConditionalInfoHeader;
